import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import { FontFamily } from '@tiptap/extension-font-family';
import FontSize from "beaktShared/components/TipTap/FontSize";
import "assets/css/tiptap.css";

// Exibe o HTML de um comunicado (gerado pelo ComunicadoForm) em modo somente leitura.
// Usa as mesmas extensoes do editor para preservar fonte, tamanho e alinhamento; o schema do
// ProseMirror descarta qualquer marcacao desconhecida, sem recorrer a dangerouslySetInnerHTML.
export default function ComunicadoConteudo({ html }) {
    const editor = useEditor({
        editable: false,
        extensions: [
            StarterKit,
            TextStyle,
            FontFamily,
            FontSize,
            TextAlign.configure({ types: ['heading', 'paragraph'] })
        ],
        content: html || ""
    });

    useEffect(() => {
        if (editor && !editor.isDestroyed)
            editor.commands.setContent(html || "");
    }, [editor, html]);

    return <EditorContent editor={editor} style={{ width: "100%" }} />;
}
